import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search, Loader2, SlidersHorizontal } from 'lucide-react';
import { market } from '../lib/api';
import CatalogCard from '../components/CatalogCard';

const SORTS = [['new', 'Newest'], ['price_asc', 'Price: low to high'], ['price_desc', 'Price: high to low'], ['discount', 'Biggest discount']];

export default function Catalog() {
  const [sp, setSp] = useSearchParams();
  const [data, setData] = useState(null);
  const [q, setQ] = useState(sp.get('q') || '');
  const params = Object.fromEntries(sp.entries());

  useEffect(() => {
    setData(null);
    market.search(Object.fromEntries(sp.entries())).then(setData).catch(() => setData({ items: [], brands: [], categories: [] }));
  }, [sp]);

  const setParam = (k, v) => { const n = new URLSearchParams(sp); if (v) n.set(k, v); else n.delete(k); setSp(n); };

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 space-y-5" data-testid="catalog-page">
      <h1 className="font-heading font-black text-3xl md:text-4xl">Shop all of India</h1>
      <form onSubmit={e => { e.preventDefault(); setParam('q', q.trim()); }} className="flex items-center gap-2 rounded-lg border-2 border-ink bg-white pl-4 pr-2 py-2 max-w-2xl">
        <Search className="w-5 h-5"/>
        <input data-testid="catalog-search-input" value={q} onChange={e => setQ(e.target.value)} placeholder="Search products, brands, manufacturers…" className="flex-1 outline-none text-sm bg-transparent"/>
        <button data-testid="catalog-search-btn" className="btn-primary !py-1.5 text-sm">Search</button>
      </form>
      <div className="flex flex-wrap items-center gap-2 text-sm" data-testid="catalog-filters">
        <SlidersHorizontal className="w-4 h-4 text-ink/60"/>
        <select data-testid="catalog-filter-category" value={params.category || ''} onChange={e => setParam('category', e.target.value)} className="rounded-full border border-border px-3 py-1.5 bg-white">
          <option value="">All categories</option>{(data?.categories || []).map(c => <option key={c}>{c}</option>)}
        </select>
        <select data-testid="catalog-filter-brand" value={params.brand || ''} onChange={e => setParam('brand', e.target.value)} className="rounded-full border border-border px-3 py-1.5 bg-white">
          <option value="">All brands</option>{(data?.brands || []).map(b => <option key={b.slug} value={b.slug}>{b.name}</option>)}
        </select>
        <input data-testid="catalog-filter-min" type="number" min="0" placeholder="Min ₹" defaultValue={params.min_price || ''} onBlur={e => setParam('min_price', e.target.value)} onKeyDown={e => e.key === 'Enter' && e.currentTarget.blur()} className="w-24 rounded-full border border-border px-3 py-1.5"/>
        <input data-testid="catalog-filter-max" type="number" min="0" placeholder="Max ₹" defaultValue={params.max_price || ''} onBlur={e => setParam('max_price', e.target.value)} onKeyDown={e => e.key === 'Enter' && e.currentTarget.blur()} className="w-24 rounded-full border border-border px-3 py-1.5"/>
        <select data-testid="catalog-sort" value={params.sort || 'new'} onChange={e => setParam('sort', e.target.value)} className="rounded-full border border-border px-3 py-1.5 bg-white">
          {SORTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
      {!data ? <Loader2 className="w-6 h-6 animate-spin text-[#E67E22]"/> : data.items.length === 0 ? (
        <p data-testid="catalog-empty" className="text-ink/60">No products match. Try another search or remove filters.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="catalog-grid">
          {data.items.map(p => <CatalogCard key={p.id} p={p}/>)}
        </div>
      )}
    </div>
  );
}
